(() => {
    const sectionScript = document.currentScript;
    if (!sectionScript) return;
    const sectionId = sectionScript.dataset.sectionId;
    const sectionSelector = '#shopify-section-' + sectionId;
    const registry = window.__cRankingSectionRegistry || (window.__cRankingSectionRegistry = {});
    let swiperInstance = null;
    const slidesPerViewMobile = Number(sectionScript.dataset.slidesPerViewMobile);
    const slidesPerViewDesktop = Number(sectionScript.dataset.slidesPerViewDesktop);

    if (registry[sectionId] && typeof registry[sectionId].cleanup === 'function') {
        registry[sectionId].cleanup();
    }

    const destroySlider = function() {
        if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
        }
    };

    const initializeSection = function(sectionRoot) {
        if (!sectionRoot || !sectionRoot.matches(sectionSelector) || typeof Swiper === 'undefined') {
            return;
        }

        const swiperElement = sectionRoot.querySelector(`[data-swiper-id="ranking-slider-${sectionId}"]`);

        if (!swiperElement) {
            return;
        }

        if (swiperInstance) {
            swiperInstance.update();
            return;
        }

        const prevButton = sectionRoot.querySelector(`[data-prev-${sectionId}]`);
        const nextButton = sectionRoot.querySelector(`[data-next-${sectionId}]`);

        swiperInstance = new Swiper(swiperElement, {
            slidesPerView: slidesPerViewMobile,
            slidesPerGroup: 1,
            spaceBetween: 16,
            loop: false,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
            },
            breakpoints: {
                751: {
                    slidesPerView: slidesPerViewDesktop,
                    spaceBetween: 55,
                }
            },
            watchOverflow: true
        });
    };

    const initialSection = document.querySelector(sectionSelector);
    initializeSection(initialSection);

    const handleSectionLoad = function(event) {
        initializeSection(event.target);
    };

    const handleSectionUnload = function(event) {
        if (event.target && event.target.matches(sectionSelector)) {
            destroySlider();
        }
    };

    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('shopify:section:unload', handleSectionUnload);

    registry[sectionId] = {
        cleanup: function() {
            destroySlider();
            document.removeEventListener('shopify:section:load', handleSectionLoad);
            document.removeEventListener('shopify:section:unload', handleSectionUnload);
        }
    };
})();
